import React from 'react'

import { Link } from '@ally/metronome-ui'
import { useParams } from 'react-router-dom'

interface DisputeLinkProps {
  transactionId: string
  transactionSequenceNumber: number
}

export const DisputeLink: React.FC<DisputeLinkProps> = ({
  transactionId,
  transactionSequenceNumber,
}) => {
  const { id } = useParams<{ id: string }>()
  return (
    <Link
      to={`/bank/accounts/disputes-redirect/${id}/${transactionId}/${transactionSequenceNumber}`}
      text="Dispute This Transaction"
    />
  )
}
